import moment from 'moment';

import {
    PREVIOUS_30_DAYS,
    PREVIOUS_MONTH,
    PREVIOUS_QUARTER,
    PREVIOUS_YEAR,
} from '../common/constants/definitions';

const DAYS_UPPER_BOUNDS = 32;
const DAYS_LOWER_BOUNDS = 3;
const WEEKS_LOWER_BOUNDS = 21;
const WEEKS_UPPER_BOUNDS = 210;
const MONTH_LOWER_BOUNDS = 88;

export const getDiffInDaysFromPeriod = ( period ) => {
    const currentDate = moment.utc();
    const startOfPeriod = moment.utc().startOf( period );
    return currentDate.diff( startOfPeriod, 'days' );
};

export const getIntervalsForYear = ( numOfDays ) => {
    const emptyArray = [];
    if( numOfDays > WEEKS_UPPER_BOUNDS ){
        return ['month'];
    }
    if( numOfDays > MONTH_LOWER_BOUNDS && numOfDays <= WEEKS_UPPER_BOUNDS ){
        return ['week', 'month'];
    }
    if( numOfDays > DAYS_UPPER_BOUNDS && numOfDays <= MONTH_LOWER_BOUNDS ){
        return ['week'];
    }
    if( numOfDays >= WEEKS_LOWER_BOUNDS && numOfDays <= DAYS_UPPER_BOUNDS ){
        return ['day',  'week'];
    }
    if( numOfDays >= DAYS_LOWER_BOUNDS ){
        return ['day'];
    }
    return emptyArray;
};

export const getIntervalsForQuarter = ( numOfDays ) => {
    const emptyArray = [];
    if( numOfDays > DAYS_UPPER_BOUNDS ){
        return ['week'];
    }
    if( numOfDays >= WEEKS_LOWER_BOUNDS && numOfDays <= DAYS_UPPER_BOUNDS ){
        return ['day', 'week'];
    }
    if( numOfDays >= DAYS_LOWER_BOUNDS ){
        return ['day'];
    }
    return emptyArray;
};

const commonIntervalOptions = ( option ) => {
    const dict = {
        day: () => ( {
            display: 'by day',
            key: 'day',
        } ),
        month: () => ( {
            display: 'by month',
            key: 'month',
        } ),
        quarter: () => ( {
            display: 'by quarter',
            key: 'quarter',
        } ),
        week: () => ( {
            display: 'by week',
            key: 'week',
        } ),
    };

    return dict[option]();
};

const getYTD = () => {
    let ytdOptions = [];
    const ytdIntervals = getYTDIntervals();
    if( ytdIntervals.length > 0 ){
        for( let i = 0; i < ytdIntervals.length; i++ ){
            ytdOptions.push( commonIntervalOptions( ytdIntervals[i] ) );
        }
    }
    return ytdOptions;
};

const getQTD = () => {
    let qtdOptions = [];
    const qtdIntervals = getQTDIntervals();
    if( qtdIntervals.length > 0 ){
        for( let i = 0; i < qtdIntervals.length; i++ ){
            qtdOptions.push( commonIntervalOptions( qtdIntervals[i] ) );
        }
    }
    return qtdOptions;
};

export const addDynamicOptions = ( options, qtdOptions, ytdOptions ) => {
    if( qtdOptions.length > 0 ){
        options.qtd = qtdOptions;
    }

    if( ytdOptions.length > 0 ){
        options.ytd = ytdOptions;
    }
};

export const getYTDIntervals = () => {
    return getIntervalsForYear( getDiffInDaysFromPeriod( 'year' ) );
};

export const getQTDIntervals = () => {
    return getIntervalsForQuarter( getDiffInDaysFromPeriod( 'quarter' ) );
};

export const buildIntervalOptions = ( selectedDateOption ) => {
    const options = {
        [PREVIOUS_30_DAYS]: [commonIntervalOptions( 'day' ), commonIntervalOptions( 'week' )],
        [PREVIOUS_MONTH]: [commonIntervalOptions( 'day' ), commonIntervalOptions( 'week' )],
        [PREVIOUS_QUARTER]: [commonIntervalOptions( 'week' ), commonIntervalOptions( 'month' )],
        [PREVIOUS_YEAR]: [commonIntervalOptions( 'month' ), commonIntervalOptions( 'quarter' )],
    };
    addDynamicOptions( options, getQTD(), getYTD() );
    return options[selectedDateOption] ? options[selectedDateOption] : options[PREVIOUS_YEAR];
};
